import React, { useState, useEffect, useContext } from 'react';
import { getBankGradings, deleteBank } from '../../common/constants/api';
import { tableRows } from './BankDetail.module.css';
import EditIcon from '@material-ui/icons/Edit';
import EditBank from './EditBank';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/pro-solid-svg-icons';
import Toast from '../../common/components/Toast/Toast';
import { CircularProgress } from '@material-ui/core';
import { DeveloperDataContext } from '../../../../lems-ui/src/pages/app';
import ConfirmationModal from '../../common/components/Modal/ConfirmationModal';

const BankDetailsRow = props => {
  const { each, companyId } = props;
  const [data, setData] = useState({});
  const [showEditBankModal, setShowEditBankModal] = useState(false);
  const [showEditBank, setEditBank] = useState(false);
  const [askConfirmation, setConfirmation] = useState(false);

  const context = useContext(DeveloperDataContext);

  const tableBody = `font-roboto text-md font-light px-3 py-4 `;

  useEffect(() => {
    setData(each || {});
  }, [each, context.appData.bankReload]);

  const handleDelete = () => {
    setConfirmation(true);
  };

  const handleDeleteBank = () => {
    deleteBank(data?.id)
      .then(res => {
        setConfirmation(false);
        context.setAppData({
          ...context.appData,
          bankReload: !context.appData.bankReload
        });
      })
      .catch(() => {});
    Toast(
      'success',
      'Bank has been deleted successfully',
      '3000',
      'top-center'
    );
  };

  return (
    <tr className={`${tableRows}`}>
      <td className={`${tableBody} pl-5 text-blue-600`}>
        <div className="w-full flex justify-end"></div>
        <div className="w-full flex items-center justify-between">
          <p>{data?.companyRating || '--'}</p>
          <div className="w-9 flex gap-x-1 xmd:gap-x-2 md:mr-2 xmd:mr-7 xxmd:mr-16">
            <FontAwesomeIcon
              icon={faTrash}
              className="text-grey-920 cursor-pointer"
              onClick={e => {
                handleDelete();
                e.stopPropagation();
              }}
            />
            <EditIcon
              className="text-sm text-grey-920 cursor-pointer"
              onClick={e => {
                setShowEditBankModal(true), setEditBank(true);
                e.stopPropagation();
              }}
            />
          </div>
          <ConfirmationModal
            headText="Bank Details"
            bodyText="This will delete the Bank details row."
            proceedTextShow={true}
            buttonShow={true}
            handleClickYes={handleDeleteBank}
            askConfirmation={askConfirmation}
            setConfirmation={setConfirmation}
          />
        </div>
        {showEditBank ? (
          <EditBank
            showModal={showEditBankModal}
            setShowModal={setShowEditBankModal}
            setEditBank={setEditBank}
            data={data}
            companyId={companyId}
          />
        ) : null}
      </td>
      <td className={`${tableBody}`}>{data.branchName || '--'}</td>
      <td className={`${tableBody}`}>{data.employerMasterNumber || '--'}</td>
      <td
        className={`${tableBody} ${
          data?.industryRating === false
            ? `text-red-wildWatermelon`
            : `text-green-1100`
        }`}
      >
        {data?.industryRating ? 'Positive' : 'Negative'}
      </td>
      <td
        className={`${tableBody} ${
          data?.segmentRating === false
            ? `text-red-wildWatermelon`
            : `text-green-1100`
        }`}
      >
        {data?.segmentRating ? 'Positive' : 'Negative'}
      </td>
    </tr>
  );
};

const BankDetails = ({ companyId, bankId }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const context = useContext(DeveloperDataContext);

  const tableHead =
    'font-barlow py-4 text-grey-ShuttleGray text-base font-medium px-3 sticky top-0 bg-white';

  useEffect(() => {
    setLoading(true);
    setData([]);
    getBankGradings(companyId, bankId).then(res => {
      setLoading(false);
      setData(res || []);
    });
  }, [bankId, context.appData.bankReload]);

  return (
    <div className="h-88 relative">
      <table className="w-full table">
        <thead>
          <tr>
            <td className={`${tableHead} pl-5`}>Company Rating</td>
            <td className={tableHead}>Empanelling Branch</td>
            <td className={tableHead}>Employer Master no.</td>
            <td className={tableHead}>Industry Rating</td>
            <td className={tableHead}>Segment Rating</td>
          </tr>
        </thead>
        {loading ? (
          <div className="absolute w-full flex justify-center mt-10">
            <CircularProgress />
          </div>
        ) : (
          <tbody>
            {data.map((each, i) => (
              <BankDetailsRow
                each={each}
                companyId={companyId}
                id={`bankdetails${i}`}
              />
            ))}
          </tbody>
        )}
      </table>
    </div>
  );
};

export default BankDetails;
